import { waitValue } from '@/utils/promises.js'
export default {
  props: {
    filterID: { required: true }
  },
  watch: {
    'filterID': {
      immediate: true,
      handler () {
        if (!this.filterID) return
        this.getGrid()
          .then((grid) => {
            this.loadData(grid)
          })
      }
    }
  },
  data () {
    return {
      timerID: null
    }
  },
  methods: {
    getGrid () {
      return waitValue(() => this.$refs['grid'])
    },
    loadData () {
      console.error("THE METHOD 'LOAD DATA' IS REQUIRED")
    }
  }
}
